import { ReactComponent as ArticlesIcon } from "../../icons/ARTICLES.svg";
import { ReactComponent as BackIcon } from "../../icons/BACK.svg";
import { ReactComponent as BelieverIcon } from "../../icons/BELIEVER.svg";
import { ReactComponent as BooksIcon } from "../../icons/BOOKS.svg";
import { ReactComponent as CheckmarkIcon } from "../../icons/CHECKMARK.svg";
import { ReactComponent as CollectionIcon } from "../../icons/COLLECTION.svg";
import { ReactComponent as ConnectIcon } from "../../icons/CONNECT.svg";
import { ReactComponent as CreateIcon } from "../../icons/CREATE.svg";
import { ReactComponent as CuratorIcon } from "../../icons/CURATOR.svg";
import { ReactComponent as DeleteIcon } from "../../icons/DELETE.svg";
import { ReactComponent as DisconnectIcon } from "../../icons/DISCONNECT.svg";
import { ReactComponent as EditIcon } from "../../icons/EDIT.svg";
import { ReactComponent as EnterIcon } from "../../icons/ENTER.svg";
import { ReactComponent as EverythingAltIcon } from "../../icons/EVERYTHING ALT.svg";
import { ReactComponent as EverythingIcon } from "../../icons/EVERYTHING.svg";
import { ReactComponent as ExpandIcon } from "../../icons/EXPAND.svg";
import { ReactComponent as ExploreIcon } from "../../icons/EXPLORE.svg";
import { ReactComponent as FavoritesIcon } from "../../icons/FAVORITES.svg";
import { ReactComponent as FilesIcon } from "../../icons/FILES.svg";
import { ReactComponent as FiltersIcon } from "../../icons/FILTERS.svg";
import { ReactComponent as FollowingIcon } from "../../icons/FOLLOWING.svg";
import { ReactComponent as HighlightsIcon } from "../../icons/HIGHLIGHTS.svg";
import { ReactComponent as JumpIcon } from "../../icons/JUMP.svg";
import { ReactComponent as ListenIcon } from "../../icons/LISTEN.svg";
import { ReactComponent as MoreIcon } from "../../icons/MORE.svg";
import { ReactComponent as NotesIcon } from "../../icons/NOTES.svg";
import { ReactComponent as NotificationsIcon } from "../../icons/NOTIFICATIONS.svg";
import { ReactComponent as PeopleIcon } from "../../icons/PEOPLE.svg";
import { ReactComponent as PicturesIcon } from "../../icons/PICTURES.svg";
import { ReactComponent as PinnedIcon } from "../../icons/PINNED.svg";
import { ReactComponent as PlusIcon } from "../../icons/PLUS.svg";
import { ReactComponent as PremiumIcon } from "../../icons/PREMIUM.svg";
import { ReactComponent as PreviewIcon } from "../../icons/PREVIEW.svg";
import { ReactComponent as RelevantIcon } from "../../icons/RELEVANT.svg";
import { ReactComponent as SearchIcon } from "../../icons/SEARCH.svg";
import { ReactComponent as SerendipityIcon } from "../../icons/SERENDIPITY.svg";
import { ReactComponent as SettingsIcon } from "../../icons/SETTINGS.svg";
import { ReactComponent as ShareIcon } from "../../icons/SHARE.svg";
import { ReactComponent as SortIcon } from "../../icons/SORT.svg";
import { ReactComponent as StaffPicksIcon } from "../../icons/STAFF PICKS.svg";
import { ReactComponent as TextsIcon } from "../../icons/TEXTS.svg";
import { ReactComponent as TweetsIcon } from "../../icons/TWEETS.svg";
import { ReactComponent as UnfavoriteIcon } from "../../icons/UNFAVORITE.svg";
import { ReactComponent as UnpinIcon } from "../../icons/UNPIN.svg";
import { ReactComponent as VideosIcon } from "../../icons/VIDEOS.svg";
import { ReactComponent as WebsitesIcon } from "../../icons/WEBSITES.svg";
import { ReactComponent as XIcon } from "../../icons/X.svg";

export enum IconNames {
  Articles = "@sublime/articles",
  Back = "@sublime/back",
  Believer = "@sublime/believer",
  Books = "@sublime/books",
  Checkmark = "@sublime/checkmark",
  Collection = "@sublime/collection",
  Connect = "@sublime/connect",
  Create = "@sublime/create",
  Curator = "@sublime/curator",
  Delete = "@sublime/delete",
  Disconnect = "@sublime/disconnect",
  Edit = "@sublime/edit",
  Enter = "@sublime/enter",
  Everything = "@sublime/everything",
  EverythingAlt = "@sublime/everything-alt",
  Expand = "@sublime/expand",
  Explore = "@sublime/explore",
  Favorites = "@sublime/favorites",
  Files = "@sublime/files",
  Filters = "@sublime/filters",
  Following = "@sublime/following",
  Highlights = "@sublime/highlights",
  Jump = "@sublime/jump",
  Listen = "@sublime/listen",
  More = "@sublime/more",
  Notes = "@sublime/notes",
  Notifications = "@sublime/notifications",
  People = "@sublime/people",
  Pictures = "@sublime/pictures",
  Pinned = "@sublime/pinned",
  Plus = "@sublime/plus",
  Premium = "@sublime/premium",
  Preview = "@sublime/preview",
  Relevant = "@sublime/relevant",
  Search = "@sublime/search",
  Serendipity = "@sublime/serendipity",
  Settings = "@sublime/settings",
  Share = "@sublime/share",
  Sort = "@sublime/sort",
  StaffPicks = "@sublime/staff-picks",
  Texts = "@sublime/texts",
  Tweets = "@sublime/tweets",
  Unfavorite = "@sublime/unfavorite",
  Unpin = "@sublime/unpin",
  Videos = "@sublime/videos",
  Websites = "@sublime/websites",
  X = "@sublime/x",
}

const IconsDictionary = {
  [`${IconNames.Articles}`]: {
    component: ArticlesIcon,
  },
  [IconNames.Back]: {
    component: BackIcon,
  },
  [IconNames.Believer]: {
    component: BelieverIcon,
  },
  [IconNames.Books]: {
    component: BooksIcon,
  },
  [IconNames.Checkmark]: {
    component: CheckmarkIcon,
  },
  [IconNames.Collection]: {
    component: CollectionIcon,
  },
  [IconNames.Connect]: {
    component: ConnectIcon,
  },
  [IconNames.Create]: {
    component: CreateIcon,
  },
  [IconNames.Curator]: {
    component: CuratorIcon,
  },
  [IconNames.Delete]: {
    component: DeleteIcon,
  },
  [IconNames.Disconnect]: {
    component: DisconnectIcon,
  },
  [IconNames.Edit]: {
    component: EditIcon,
  },
  [IconNames.Enter]: {
    component: EnterIcon,
  },
  [IconNames.Everything]: {
    component: EverythingIcon,
  },
  [IconNames.EverythingAlt]: {
    component: EverythingAltIcon,
  },
  [IconNames.Expand]: {
    component: ExpandIcon,
  },
  [IconNames.Explore]: {
    component: ExploreIcon,
  },
  [IconNames.Favorites]: {
    component: FavoritesIcon,
  },
  [IconNames.Files]: {
    component: FilesIcon,
  },
  [IconNames.Filters]: {
    component: FiltersIcon,
  },
  [IconNames.Following]: {
    component: FollowingIcon,
  },
  [IconNames.Highlights]: {
    component: HighlightsIcon,
  },
  [IconNames.Jump]: {
    component: JumpIcon,
  },
  [IconNames.Listen]: {
    component: ListenIcon,
  },
  [IconNames.More]: {
    component: MoreIcon,
  },
  [IconNames.Notes]: {
    component: NotesIcon,
  },
  [IconNames.Notifications]: {
    component: NotificationsIcon,
  },
  [IconNames.People]: {
    component: PeopleIcon,
  },
  [IconNames.Pictures]: {
    component: PicturesIcon,
  },
  [IconNames.Pinned]: {
    component: PinnedIcon,
  },
  [IconNames.Plus]: {
    component: PlusIcon,
  },
  [IconNames.Premium]: {
    component: PremiumIcon,
  },
  [IconNames.Preview]: {
    component: PreviewIcon,
  },
  [IconNames.Relevant]: {
    component: RelevantIcon,
  },
  [IconNames.Search]: {
    component: SearchIcon,
  },
  [IconNames.Serendipity]: {
    component: SerendipityIcon,
  },
  [IconNames.Settings]: {
    component: SettingsIcon,
  },
  [IconNames.Share]: {
    component: ShareIcon,
  },
  [IconNames.Sort]: {
    component: SortIcon,
  },
  [IconNames.StaffPicks]: {
    component: StaffPicksIcon,
  },
  [IconNames.Texts]: {
    component: TextsIcon,
  },
  [IconNames.Tweets]: {
    component: TweetsIcon,
  },
  [IconNames.Unfavorite]: {
    component: UnfavoriteIcon,
  },
  [IconNames.Unpin]: {
    component: UnpinIcon,
  },
  [IconNames.Videos]: {
    component: VideosIcon,
  },
  [IconNames.Websites]: {
    component: WebsitesIcon,
  },
  [IconNames.X]: {
    component: XIcon,
  },
};

export const Icon: React.FC<
  {
    name: string;
    color?: string;
    size?: number;
  } & React.HTMLProps<HTMLElement>
> = ({ name, color, size, ...props }) => {
  const { component: Component } = IconsDictionary[name];

  return <Component {...props as any} />;
};
